import { c as _c } from "react/compiler-runtime";
import { api } from "@shared-server/api";
import { Card, CardContent } from "./shadcn/card";
import Image from "next/image";
import Link from "next/link";
interface ADUserCardProps {
  imagePath?: string | null;
  userPrincipalName: string;
}
export const ADUserCard = props => {
  const $ = _c(20);
  const t0 = props.userPrincipalName || "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      userPrincipalName: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!props.userPrincipalName;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const userQuery = api.msGraph.user.useQuery(t1, t3);
  const user = userQuery.data;
  if (!user) {
    return null;
  }
  let t4;
  if ($[4] !== props.imagePath || $[5] !== userQuery.data?.displayName) {
    t4 = props.imagePath && <div><Image src={props.imagePath} alt={userQuery.data?.displayName || "User Profile Image"} width={64} height={64} className="rounded-full mr-4" /></div>;
    $[4] = props.imagePath;
    $[5] = userQuery.data?.displayName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = userQuery.data?.displayName;
  let t6;
  if ($[7] !== t5) {
    t6 = <h2 className="mb-0 mt-2">{t5}</h2>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = user?.jobTitle;
  let t8;
  if ($[9] !== t7) {
    t8 = <div>{t7}</div>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== user) {
    t9 = user?.mail && <Link className="hover:text-ter-green-500" href={`mailto:${user.mail.toLowerCase()}`}>{user.mail.toLowerCase()}</Link>;
    $[11] = user;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t6}{t8}{t9}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t4) {
    t11 = <Card className="m-2 shadow-md text-foreground"><CardContent className="p-4"><div className="flex flex-row">{t4}{t10}</div></CardContent></Card>;
    $[17] = t10;
    $[18] = t4;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};